module.exports={Remove:"Entfernen"};